(function () {
  'use strict';

  // Each gs-* section includes this file: run once.
  if (window.__gsGettingStarted) return;
  window.__gsGettingStarted = true;

  var DESKTOP = 1024;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var slice = function (list) { return Array.prototype.slice.call(list); };

  /* =====================================================================
     PAGE-LEVEL: header offset, fixed navigation (rail + mobile bar), scrollspy
     ===================================================================== */
  var page = { pages: [], bands: [], nav: null, rail: null, bar: null, track: null, steps: [], items: [], ids: [], current: null };
  var lastHeader = { visible: -1, full: -1 };

  function collect() {
    page.pages = slice(document.querySelectorAll('.gs-page'));
    page.bands = slice(document.querySelectorAll('[data-gs-band]'));
    page.nav = document.querySelector('[data-gs-nav]');
    page.rail = page.nav ? page.nav.querySelector('.progress-nav') : null;
    page.bar = page.nav ? page.nav.querySelector('.progress-nav-mobile') : null;
    page.track = page.nav ? page.nav.querySelector('[data-gs-pnm-track]') : null;
    page.steps = page.nav ? slice(page.nav.querySelectorAll('.pn-step')) : [];
    page.items = page.nav ? slice(page.nav.querySelectorAll('.pnm-item')) : [];
    page.ids = page.steps.map(function (s) { return s.getAttribute('data-step'); });
    page.current = null;
    lastHeader.visible = lastHeader.full = -1;
    document.documentElement.classList.toggle('gs-has-nav', !!page.nav && page.bands.length > 0);
  }

  function measureHeader() {
    var header = document.getElementById('header-component');
    var hs = header ? (header.closest('.header-section') || header) : null;
    var visible = 0;
    var full = 0;
    if (hs) {
      full = hs.offsetHeight;
      var idle = header.getAttribute('data-sticky-state') === 'idle';
      var pos = getComputedStyle(hs).position;
      var rect = hs.getBoundingClientRect();
      if ((pos === 'sticky' || pos === 'fixed') && !idle && rect.bottom > 0) visible = Math.round(rect.bottom);
    }
    if (visible !== lastHeader.visible || full !== lastHeader.full) {
      lastHeader.visible = visible;
      lastHeader.full = full;
      page.pages.forEach(function (p) {
        p.style.setProperty('--gs-header-offset', visible + 'px');
        p.style.setProperty('--gs-header-h', full + 'px');
      });
    }
    return visible;
  }

  function positionNav(headerBottom) {
    if (!page.bands.length) return;
    var first = page.bands[0].getBoundingClientRect();
    var last = page.bands[page.bands.length - 1].getBoundingClientRect();
    var isDesktop = window.innerWidth >= DESKTOP;

    if (page.rail && isDesktop) {
      // stays in the left column: below the header, never above the first band, never below the last one
      var y = Math.max(headerBottom, first.top);
      y = Math.min(y, last.bottom - page.rail.offsetHeight);
      page.rail.style.transform = 'translateY(' + Math.round(y) + 'px)';
      page.rail.classList.add('is-ready');
    }

    if (page.bar) {
      var barH = page.bar.offsetHeight;
      var show = !isDesktop && first.bottom <= headerBottom + 1 && last.bottom > headerBottom + barH;
      page.bar.style.top = headerBottom + 'px';
      page.bar.classList.toggle('is-visible', show);
      if (show) page.bar.removeAttribute('inert'); else page.bar.setAttribute('inert', '');
    }
  }

  function centerPnmItem(item) {
    if (!page.track || !item) return;
    var target = item.offsetLeft - (page.track.clientWidth / 2) + (item.offsetWidth / 2);
    var max = page.track.scrollWidth - page.track.clientWidth;
    page.track.scrollTo({ left: Math.max(0, Math.min(target, max)), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  }

  function setActive(id) {
    if (id === page.current) return;
    page.current = id;
    var idx = page.ids.indexOf(id);
    page.steps.forEach(function (step, stepIdx) {
      var isActive = idx >= 0 && stepIdx === idx;
      step.classList.toggle('active', isActive);
      step.classList.toggle('done', idx >= 0 && stepIdx < idx);
      if (isActive) step.setAttribute('aria-current', 'location'); else step.removeAttribute('aria-current');
    });
    page.items.forEach(function (item) {
      var isActive = item.getAttribute('data-step') === id;
      item.classList.toggle('active', isActive);
      if (isActive) { item.setAttribute('aria-current', 'location'); centerPnmItem(item); }
      else item.removeAttribute('aria-current');
    });
  }

  function computeActive(headerBottom) {
    if (!page.ids.length) return;
    var navH = window.innerWidth >= DESKTOP ? 0 : (page.bar ? page.bar.offsetHeight : 0);
    var line = headerBottom + navH + window.innerHeight * 0.3;
    var active = null;
    page.ids.forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.getBoundingClientRect().top <= line) active = id;
    });
    // at the very bottom of the page, the last step is always active
    if ((window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight - 4) {
      var lastEl = document.getElementById(page.ids[page.ids.length - 1]);
      if (lastEl && lastEl.getBoundingClientRect().top < window.innerHeight) active = page.ids[page.ids.length - 1];
    }
    setActive(active);
  }

  var ticking = false;
  function update() {
    ticking = false;
    var headerBottom = measureHeader();
    positionNav(headerBottom);
    computeActive(headerBottom);
  }
  function requestUpdate() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }
  // the theme header animates in/out: re-measure once its transition has settled
  var settleTimer = null;
  window.addEventListener('scroll', function () {
    requestUpdate();
    clearTimeout(settleTimer);
    settleTimer = setTimeout(requestUpdate, 320);
  }, { passive: true });
  window.addEventListener('resize', requestUpdate);
  window.addEventListener('load', requestUpdate);

  /* =====================================================================
     PER-SECTION FEATURES (initialised on each [data-gs-band])
     ===================================================================== */
  var instances = new WeakMap();

  function initBand(root) {
    if (!root || instances.has(root)) return;
    var cleanups = [];
    function on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      cleanups.push(function () { target.removeEventListener(type, fn, opts); });
    }

    /* First batch: sticky visual follows the visible step (≥900px) */
    var fbVisual = root.querySelector('[data-gs-fb-visual]');
    var fbSteps = slice(root.querySelectorAll('.fb-step[data-fb]'));
    if (fbVisual && fbSteps.length) {
      var slides = slice(fbVisual.querySelectorAll('.fb-slide'));
      var setFb = function (step) {
        fbSteps.forEach(function (s) { s.classList.toggle('active', s === step); });
        var keys = step.getAttribute('data-fb').split(' ');
        fbVisual.classList.toggle('is-split', keys.length > 1);
        slides.forEach(function (slide) {
          var k = keys.indexOf(slide.getAttribute('data-fb-key'));
          slide.classList.toggle('is-on', k > -1);
          slide.classList.toggle('is-left', keys.length > 1 && k === 0);
          slide.classList.toggle('is-right', keys.length > 1 && k === 1);
        });
      };
      if ('IntersectionObserver' in window) {
        var fbObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { if (entry.isIntersecting) setFb(entry.target); });
        }, { rootMargin: '-35% 0px -45% 0px', threshold: 0 });
        fbSteps.forEach(function (s) { fbObserver.observe(s); });
        cleanups.push(function () { fbObserver.disconnect(); });
      }
    }

    /* Video: muted autoplay only while visible, with a pause control */
    var frame = root.querySelector('[data-gs-video]');
    if (frame) {
      var video = frame.querySelector('video');
      var toggle = frame.querySelector('[data-gs-video-toggle]');
      var userPaused = reducedMotion.matches;
      var inView = false;
      var setState = function (playing) {
        if (!toggle) return;
        toggle.setAttribute('data-state', playing ? 'playing' : 'paused');
        toggle.setAttribute('aria-label', playing ? 'Mettre la vidéo en pause' : 'Lire la vidéo');
      };
      var sync = function () {
        if (!video) return;
        if (inView && !userPaused) {
          var p = video.play();
          if (p && p.catch) p.catch(function () { setState(false); });
        } else {
          video.pause();
        }
      };
      if (video) {
        video.muted = true;
        video.removeAttribute('controls');
        on(video, 'play', function () { setState(true); });
        on(video, 'pause', function () { setState(false); });
      }
      if (toggle && video) {
        on(toggle, 'click', function () {
          userPaused = !video.paused;
          if (userPaused) video.pause(); else { inView = true; sync(); }
        });
      }
      if ('IntersectionObserver' in window) {
        var vObserver = new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.4 });
        vObserver.observe(frame);
        cleanups.push(function () { vObserver.disconnect(); });
      }
    }

    /* Conversion table toggle (closed by default) */
    var convBtn = root.querySelector('[data-gs-conv-toggle]');
    var convPanel = convBtn ? document.getElementById(convBtn.getAttribute('aria-controls')) : null;
    if (convBtn && convPanel) {
      on(convBtn, 'click', function () {
        var willOpen = convPanel.hasAttribute('hidden');
        if (willOpen) convPanel.removeAttribute('hidden'); else convPanel.setAttribute('hidden', '');
        convBtn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        convBtn.textContent = convBtn.getAttribute(willOpen ? 'data-label-close' : 'data-label-open') || convBtn.textContent;
        requestUpdate();
      });
    }

    /* FAQ tabs (click + arrow keys, roving tabindex) */
    var tabList = root.querySelector('[data-gs-faq-tabs]');
    if (tabList) {
      var tabs = slice(tabList.querySelectorAll('[role="tab"]'));
      var select = function (tab, focus) {
        tabs.forEach(function (t) {
          var isOn = t === tab;
          t.setAttribute('aria-selected', isOn ? 'true' : 'false');
          t.setAttribute('tabindex', isOn ? '0' : '-1');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) { if (isOn) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', ''); }
        });
        if (focus) tab.focus();
        requestUpdate();
      };
      tabs.forEach(function (tab) { on(tab, 'click', function () { select(tab, false); }); });
      on(tabList, 'keydown', function (e) {
        var i = tabs.indexOf(document.activeElement);
        if (i < 0) return;
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); select(next, true); }
      });
      root.__gsSelectTab = function (panel) {
        var tab = tabs.filter(function (t) { return t.getAttribute('aria-controls') === panel.id; })[0];
        if (tab) select(tab, false);
      };
    }

    instances.set(root, function () { cleanups.forEach(function (fn) { fn(); }); });
  }

  function destroyBand(root) {
    var fn = root && instances.get(root);
    if (fn) { fn(); instances.delete(root); }
  }

  function initAll(scope) {
    slice((scope || document).querySelectorAll('[data-gs-band]')).forEach(initBand);
    collect();
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  /* Theme editor: re-init on reload, clean up on removal, reveal selected FAQ question */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    slice(e.target.querySelectorAll('[data-gs-band]')).forEach(destroyBand);
    setTimeout(function () { collect(); update(); }, 0);
  });
  document.addEventListener('shopify:section:reorder', function () { collect(); update(); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target;
    if (item && item.getAttribute && item.getAttribute('role') === 'tab') { item.click(); return; }
    var panel = item && item.closest ? item.closest('.faq-panel[hidden]') : null;
    var band = panel ? panel.closest('[data-gs-band]') : null;
    if (band && band.__gsSelectTab) band.__gsSelectTab(panel);
    if (item && item.tagName === 'DETAILS') item.open = true;
  });
})();
